import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import {
  Categories,
  Departments,
  LoginModel,
  SizeDetail,
  SizeModel,
  Sizes,
  UserPermissionsModel,
} from '../../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';
import { CustomToastsService } from '../../../../Services/custom-toasts.service';
import { ExportExcelService } from '../../../../Services/export-excel.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AdminBreadcrumbsService } from '../../admin-services/admin-breadcrumbs.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ImportServiceService } from '../../../../Services/import-service.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserserviceService } from 'src/app/Services/userservice.service';
import { Size } from 'igniteui-angular/lib/services/overlay/utilities';

@Component({
  selector: 'app-sizing',
  templateUrl: './sizing.component.html',
  styleUrls: ['./sizing.component.css'],
})
export class SizingComponent {
  departmentsList: Array<Departments> = [];
  categories: Array<Categories> = [];
  categoriesFilter: Array<Categories> = [];
  sizes: Array<SizeModel> = [];
  sizeDetails: Array<SizeDetail> = [];
  sizesForFilter: Array<SizeModel> = [];
  sizesFresh: Array<SizeModel> = [];
  addSizeArray: Array<SizeDetail> = [];
  sizeArrayForExport: Array<SizeModel> = [];
  sizeIdsToDel: number[] = [];
  userInfo: LoginModel = new LoginModel();
  frmText: string = 'Add New Sizes';
  selectedDepartment: string = '';
  selectedCategoryName: string = '';
  departmentIdToGetCategories: number = 0;
  categoryId: number = 0;
  sortVals: boolean = false;
  isAllFieldNotFill: boolean = false;
  showAddUpdateBtn: boolean = false;

  deptArrayForFilters: Array<SizeModel> = [];
  departmentIDsToFilter: number[] = [];
  isFilterModalOpen: boolean = false;

  importsizes: any[] = [];
  toggleAll: boolean = false;
  isImport: boolean = true;
  isImportDisabled: boolean = false;
  fileType: string = 'XLSX';
  isInvalidImport: boolean = false;
  exportColumnsArr = [['Department', 'Category', 'Size', 'Range']];
  isFilterApplied: boolean = false;

  @ViewChild('importModel') importModel!: ElementRef<HTMLButtonElement>;
  @ViewChild('importSize') importSize!: ElementRef<HTMLButtonElement>;

  constructor(
    private permissionService: NgxPermissionsService,
    private userservice: UserserviceService,
    private masterservice: MasterDataSeriveService,
    private toastr: CustomToastsService,
    private exportExcelService: ExportExcelService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private importService: ImportServiceService
  ) { }

  ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Company Config', link: 'demo' },
      { crumbName: 'Sizes', link: '/admin/home/sizing' },
    ]);

    this.userInfo = this.masterservice.getUserDetailsFromStorage();
    this.getCategories();
    this.getSizing();
    this.arrangeRowForAddingSizes();
    this.getDepartments();
    this.getPermissionsByUserId();
  }

  getCategories() {
    let userDetails = this.masterservice.getUserDetailsFromStorage();
    this.masterservice
      .getCategoryAdmin(userDetails.companyID)
      .subscribe((res) => {
        this.categories = JSON.parse(JSON.stringify(res)) as Categories[];
        this.categories = this.categories.filter(
          (category) => category.active == true
        );
        this.categoriesFilter = this.categories.filter(
          (category) => category.active == true
        );
      });
  }

  showSuccess() {
    this.toastr.success('New Size has been successfully added.');
  }

  showUpdate() {
    this.toastr.success('Size has been successfully added.');
  }

  showError() {
    this.toastr.error('Size Already Exist');
  }

  selectedDept(name: string) {
    this.selectedDepartment = name;
  }

  selectedCategory(name: string) {
    this.selectedCategoryName = name;
  }

  getSizing() {
    let companyId = this.userInfo.companyID;
    this.masterservice.getAllSizes(companyId).subscribe((res) => {
      this.sizes = res as SizeModel[];
      this.sizesForFilter = res as SizeModel[];
      this.sizesFresh = JSON.parse(JSON.stringify(res)) as SizeModel[];
      //For filter - build unique departments array with proper image data
      this.buildDeptArrayForFilters();

      if (this.departmentIDsToFilter.length) {
        this.deptArrayForFilters.forEach((ele) => {
          if (this.departmentIDsToFilter.includes(ele.departmentId)) {
            ele.isSelected = true;
          }
        });

        this.getFilterData();
      }
    });
  }

  openFilterModal(modalState: string) {
    if (modalState === 'Open') {
      this.isFilterModalOpen = true;
    }

    if (modalState === 'Close') {
      this.isFilterModalOpen = false;
      this.departmentIDsToFilter = [];
      this.deptArrayForFilters.forEach((el) => (el.isSelected = false));
    }
  }

  compareDates(dateStr1: string, dateStr2: string): number {
    const date1 = new Date(dateStr1);
    const date2 = new Date(dateStr2);

    if (date1 < date2) {
      return -1;
    } else if (date1 > date2) {
      return 1;
    } else {
      return 0;
    }
  }

  getDepartments() {
    this.masterservice.getMainDepartments().subscribe((res) => {
      this.departmentsList = res as Departments[];
      this.departmentsList = this.departmentsList.filter(
        (item) => item.active == true
      );

      // Rebuild filter array if sizes are already loaded
      if (this.sizes.length > 0) {
        this.buildDeptArrayForFilters();
      }
    });
  }

  buildDeptArrayForFilters() {
    // Get unique departments from sizes data
    const uniqueDeptIds = [
      ...new Set(this.sizes.map((size) => size.departmentId)),
    ];

    this.deptArrayForFilters = uniqueDeptIds
      .map((deptId) => {
        // Find the size record for this department
        const sizeRecord = this.sizes.find(
          (size) => size.departmentId === deptId
        );

        // Find the corresponding department record with image data
        const deptRecord = this.departmentsList.find(
          (dept) => dept.departmentId === deptId
        );

        // Create a combined record with both size and department data
        const filterItem: SizeModel = {
          departmentId: sizeRecord?.departmentId || 0,
          departmentDescr: sizeRecord?.departmentDescr || '',
          categoryId: sizeRecord?.categoryId || 0,
          categoryName: sizeRecord?.categoryName || '',
          companyId: sizeRecord?.companyId || 0,
          sizes: sizeRecord?.sizes || '',
          sizing: sizeRecord?.sizing || [],
          isSelected: false,
          dImageIcon: deptRecord?.imageIcon || '',
          imageIcon: deptRecord?.imageIcon || '',
        };

        return filterItem;
      })
      .filter((item) => item.departmentId > 0); // Remove any invalid entries
  }

  exportsizes() {
    this.masterservice.getAllSizes(this.userInfo.companyID).subscribe((res) => {
      this.sizeArrayForExport = res as SizeModel[];

      let dataToExport = this.sizeArrayForExport.flatMap((size: any) =>
        size.sizing.map((sizeDetail: SizeDetail) => ({
          Alpha_Size: sizeDetail.alphaSize,
          Size_Range: sizeDetail.numericSizeRange,
          Category: size.categoryName,
          Department: size.departmentDescr,
          Date_Created: this.removeTimeFromDateForExport(sizeDetail.createdDt),
        }))
      );
      this.exportExcelService.exportAsExcelFile(dataToExport, 'Sizes-data');
    });
  }

  removeTimeFromDateForExport(dateString: string): string {
    const dateWithoutTime = new Date(dateString);
    const day = dateWithoutTime.getDate();
    const month = dateWithoutTime.getMonth() + 1;
    const year = dateWithoutTime.getFullYear();
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDate = `${formattedMonth}-${formattedDay}-${year}`;
    return formattedDate;
  }

  collectFilterParameters(deptId: any) {
    this.deptArrayForFilters.forEach((ele) => {
      if (ele.departmentId == deptId) {
        ele.isSelected = !ele.isSelected;
        if (ele.isSelected) {
          this.departmentIDsToFilter.push(deptId);
        } else {
          this.departmentIDsToFilter = this.departmentIDsToFilter.filter(
            (item) => item != deptId
          );
        }
      }
    });

    if (!this.departmentIDsToFilter.length) {
      this.sizes = JSON.parse(JSON.stringify(this.sizesFresh));
      this.isFilterApplied = false;
    }
  }

  getFilterData() {
    if (this.departmentIDsToFilter.length > 0) {
      this.sizes = this.sizesFresh.filter((item) =>
        this.departmentIDsToFilter.includes(item.departmentId)
      );
      this.isFilterApplied = true;
    } else {
      this.sizes = JSON.parse(JSON.stringify(this.sizesFresh));
      this.isFilterApplied = false;
    }
  }

  clearFilter() {
    this.sizes = JSON.parse(JSON.stringify(this.sizesFresh));
    this.departmentIDsToFilter = [];
    this.deptArrayForFilters.forEach((el) => {
      el.isSelected = false;
    });
    this.isFilterApplied = false;
  }

  sortValues(val: any) {
    if (val == 'deptDesc') {
      this.sortVals = !this.sortVals;
      if (this.sortVals) {
        this.sizes.sort((a, b) =>
          a.departmentDescr.localeCompare(b.departmentDescr)
        );
      } else {
        this.sizes.sort((a, b) =>
          b.departmentDescr.localeCompare(a.departmentDescr)
        );
      }
    } else if (val == 'ctgDesc') {
      this.sortVals = !this.sortVals;
      if (this.sortVals) {
        this.sizes.sort((a, b) => a.categoryName.localeCompare(b.categoryName));
      } else {
        this.sizes.sort((a, b) => b.categoryName.localeCompare(a.categoryName));
      }
    }
  }

  getSizeByCategory(sizeData: SizeModel) {
    this.frmText = 'Update Sizes';
    this.selectedDepartment = sizeData.departmentDescr;
    this.selectedCategoryName = sizeData.categoryName;
    this.departmentIdToGetCategories = sizeData.departmentId;
    this.getCategoriesForDropdown(sizeData.departmentId);
    this.categoryId = sizeData.categoryId;
    this.sizeIdsToDel = [];

    this.sizeDetails = sizeData.sizing;

    // Populate addSizeArray with existing size details for editing
    this.addSizeArray = [...sizeData.sizing];

    this.showBtns();
  }

  getCategoriesForDropdown(departmentId: number) {
    this.categories = this.categoriesFilter.filter(
      (category) => category.departmentId === departmentId
    );
  }

  arrangeRowForAddingSizes() {
    for (let i = 0; i < 4; i++) {
      let size: SizeDetail = new SizeDetail();
      this.addSizeArray.push(size);
    }
  }

  addSizeRow() {
    let readyToAdd = this.addSizeArray.every(
      (item) => !!item.alphaSize && item.alphaSize.trim() !== ''
    );
    if (readyToAdd) {
      this.isAllFieldNotFill = false;
      let size: SizeDetail = new SizeDetail();
      this.addSizeArray.push(size);

      //Scrolling down for showing newly added row
      setTimeout(() => {
        const scrollableDiv =
          this.elementRef.nativeElement.querySelector('#addSizeWrapper');
        if (scrollableDiv) {
          scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
          const rows = scrollableDiv.querySelectorAll('tr.drag-row');
          const lastRow = rows[rows.length - 1] as HTMLTableRowElement;
          const firstInput = lastRow.querySelector('input') as HTMLInputElement;
          if (firstInput) {
            this.renderer.selectRootElement(firstInput).focus();
          }
        }
      });
    } else {
      this.isAllFieldNotFill = true;
    }

    this.showAddUpdateBtn = this.addSizeArray.every(
      (item) => !!item.alphaSize && item.alphaSize.trim() !== ''
    );
  }

  deleteSizeRow(indx: number) {
    if (this.frmText == 'Update Sizes') {
      this.sizeIdsToDel.push(this.addSizeArray[indx].sizeId);
    }

    this.addSizeArray.splice(indx, 1);
    this.showAddUpdateBtn = this.addSizeArray.every(
      (item) => !!item.alphaSize && item.alphaSize.trim() !== ''
    );
  }

  resetFields() {
    this.frmText = 'Add New Sizes';
    this.isAllFieldNotFill = false;
    this.showAddUpdateBtn = false;
    this.departmentIdToGetCategories = 0;
    this.categoryId = 0;
    this.addSizeArray = [];
    this.arrangeRowForAddingSizes();
  }

  showBtns() {
    this.showAddUpdateBtn = this.addSizeArray.every(
      (item) => !!item.alphaSize && item.alphaSize.trim() !== ''
    );
  }

  addUpdateSizes() {
    // Convert SizeDetail array to Sizes array for the API
    let sizesToSend: Sizes[] = this.addSizeArray.map((detail, i) => {
      let size = new Sizes();
      size.sizeID = detail.sizeId;
      size.alphaSize = detail.alphaSize;
      size.sizeMethod = detail.sizeMethod;
      size.numericSizeRange = detail.numericSizeRange;
      size.departmentId = this.departmentIdToGetCategories;
      size.categoryId = this.categoryId;
      size.companyID = this.userInfo.companyID;
      size.sortOrder = i + 1;
      size.active = true;
      return size;
    });

    if (this.sizeIdsToDel.length) {
      this.deleteSizes(this.sizeIdsToDel);
    }

    this.masterservice.addUpdateSize(sizesToSend).subscribe({
      next: (res) => {
        if (res) {
          if (this.frmText === 'Add New Sizes') {
            this.toastr.success('Sizes has been added under the category');
          } else {
            this.toastr.success('Sizes has been updated under the category');
          }
          this.getSizing();
          this.resetFields();
        } else {
          this.toastr.error('Sizes not added');
        }
      },
      error: (err) => {
        if (err?.error?.extensions?.Message) {
          this.toastr.error(err?.error?.extensions?.Message);
        } else {
          this.toastr.error('An unexpected error occurred.');
        }
      },
    });
  }

  async deleteSizes(sizesToDel: number[]) {
    let ids = sizesToDel.join();
    await this.masterservice.deleteSizes(ids).subscribe((res) => {
      if (res && this.frmText == 'Add New Sizes') {
        this.toastr.success('Sizes has been deleted under the category');
      }
      this.sizeIdsToDel = [];
      this.getSizing();
    });
  }

  drropSizeRow(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.addSizeArray, event.previousIndex, event.currentIndex);
  }

  exportSizes() {
    const data = [
      this.exportColumnsArr[0],
      ['Sample Department', 'Parent Category, Subcategory', 'SM', '']
    ];
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sizes');
    const wbout: Blob = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    FileSaver.saveAs(new Blob([wbout]), 'size.xlsx');
  }
  importSizes() {
    this.isImportDisabled = false;

    if (this.importSize) {
      this.importSize.nativeElement.click();
    }
  }

  onFileChangeImport(event: any) {
    let user = this.masterservice.getUserDetailsFromStorage();
    let outletID = user.storeId;
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const rawData: any[][] = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
        }) as any[][];

        const filteredData = rawData.filter((row) =>
          row.some((cell) => cell !== null && cell !== undefined && cell !== '')
        );

        this.importsizes = await this.transformToJsonArray(filteredData);

        this.importsizes.forEach((item) => {
          item.createdByUserID = user.userId;
          item.companyID = user.companyID;
          item.outletID = outletID;
          item.isChecked = false;
          item.addStatus = 2;
          item.status = null;
        });
      };

      reader.readAsBinaryString(file);
      if (this.importModel) this.importModel.nativeElement.click();
    }
  }

  transformToJsonArray(data: any[][]): any[] {
    if (data.length === 0) return [];

    const headerMapping: { [key: string]: string } = {
      Department: 'departmentDesc',
      Category: 'category',
      Size: 'size',
      Range: 'range',
    };

    const headers = data[0];
    const camelCaseHeaders = headers.map(
      (header) =>
        headerMapping[header] || header.toLowerCase().replace(/\s+/g, '')
    );

    const rows = data.slice(1);
    return rows.map((row) => {
      const obj: any = {};
      camelCaseHeaders.forEach((header, index) => {
        obj[header] = row[index];
      });
      return obj as any;
    });
  }

  checkAllImport(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.toggleAll = inputElement.checked;
    this.importsizes.forEach((item) => {
      if (item.addStatus == 2) {
        item.isChecked = inputElement.checked;
      }
    });
    this.isImportEnabled();
  }

  isImportEnabled(): void {
    let list = this.importsizes.filter((user) => user.isChecked == true);
    this.isImport = list.length > 0;
  }
  closeImportModal(): void {
    const fileInput = this.importSize.nativeElement;

    // Reset the file input value to allow re-selection of the same file
    fileInput.value = '';
  }

  addImportedDepartments() {
    this.isInvalidImport = false;
    let sizes = this.importsizes
      .filter((user) => user.isChecked == true)
      .map(({ status, ...rest }) => rest);

    if (sizes.length == 0) {
      this.toastr.error('Invalid Selection');
      return;
    }

    sizes.forEach((size) => {
      // Validate 'productname' (case-insensitive)
      if (
        size.departmentDesc == undefined &&
        size.category == undefined &&
        size.size == undefined
      ) {
        this.toastr.error('Invalid entry in import file');
        this.isInvalidImport = true;
        return;
      }
    });

    if (this.isInvalidImport) {
      return;
    }

    sizes.forEach((size) => {
      size.active = true;
      size.range = size.range != null && size.range !== '' ? size.range.toString() : '';
      size.size = size.size != null && size.size !== '' ? size.size.toString() : '';
      size.departmentDesc = size.departmentDesc
        ? size.departmentDesc.toString().trim()
        : '';
      size.category = size.category ? size.category.toString().trim() : '';
    });

    this.importService.ImportSizes(sizes).subscribe((res) => {
      this.importsizes = res as any[];
      this.importsizes.forEach((user) => {
        if (user.reason != null) {
          user.reason = user.reason
            .split(',')
            .map((reason: string) => reason.trim())
            .filter((reason: string | any[]) => reason.length > 0);
        }
      });
      //this.toastr.success("Products has been importes successfully");
      this.isImportDisabled = true;
      this.toggleAll = false;
      this.getSizing();
    });
  }

  getPermissionsByUserId() {
    this.userservice.getUserRolesandPerm().then((res) => {
      let permissions = res as UserPermissionsModel[];

      let perm: string[] = [];

      permissions?.forEach((pr) => {
        perm.push(pr.name);
      });

      this.permissionService.loadPermissions(perm);
    });
  }

  getRemainingErrors(reasonString: string): string {
    const errors = reasonString.split('|');
    return errors.slice(1).join('\n');
  }
}
